import types from './types';
const saveSummaryTemplate = ( data, extraData ) => {
    const body = data;
    return {
        type: types.SAVE_SUMMARY_TEMPLATE,
        additionalData: extraData,
        async: true,
        generalFetching: true,
        payload: {
            path: '/summaryTemplate',
            method: 'POST',
            body
        }
    };
};
export default {
    saveSummaryTemplate
};
